import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import LabelsType from '../LabelsType';
import ParameterFormatter from '../ParameterFormatter';

const MultipleNumber1Type = ({question}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.parameterList} /></h4>
        <table className="table table-sm">
            <tbody>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.min} /></th>
                    <td><ParameterFormatter value={question.min} /></td>
                </tr>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.max} /></th>
                    <td><ParameterFormatter value={question.max} /></td>
                </tr>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.step} /></th>
                    <td><ParameterFormatter value={question.step} /></td>
                </tr>
            </tbody>
        </table>
        <h4><FormattedMessage {...messages.surveys.form.label.rows} /></h4>
        <LabelsType labels={question.rows} />
    </>
);

MultipleNumber1Type.propTypes = {
    question: PropTypes.object.isRequired,
};

export default MultipleNumber1Type;
